import store from '@/store'
import { useToast } from 'vue-toastification'
import router from '@/router'

const toast = useToast()

export default (to, from, next) => {
  if (store.state.auth.jwtPayload == null){
    const targetPath = to.fullPath || to.path;
    if (targetPath && targetPath !== "/" && targetPath !== "/validation") {
      store.commit("auth/setRedirectLink", targetPath);
      sessionStorage.setItem("redirectLink", targetPath);
    }
    if (store.state.auth.currentOrganisation && store.state.auth.currentOrganisation.id && typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem("selectedOrgId", store.state.auth.currentOrganisation.id);
    }
    store.dispatch('auth/logout');
    return;
  }
  
  if (!store.state.auth.isSuperAdmin && store.state.auth.accessType == null) {
    toast.error("Only Vertex users are allowed to view this page.");
    router.push('/audits');
    return next()
  }

}

